import React from 'react';
import { X, Check, Target } from 'lucide-react';
import { philosophyData } from '../data/mock';

export const PhilosophySection = () => {
  return (
    <section id="philosophy" className="py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        {/* Section Title */}
        <h2 className="text-4xl sm:text-5xl font-extralight text-black mb-16 tracking-tight">
          {philosophyData.title}
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16">
          {/* Not This */}
          <div className="space-y-6">
            <p className="text-lg text-gray-600 font-light">
              {philosophyData.intro}
            </p>
            <ul className="space-y-4">
              {philosophyData.notList.map((item, index) => (
                <li key={index} className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
                    <X className="w-4 h-4 text-gray-400" strokeWidth={2} />
                  </div>
                  <span className="text-gray-500 font-light">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Will Be */}
          <div className="space-y-6">
            <p className="text-lg text-gray-600 font-light">
              {philosophyData.willBe}
            </p>
            <ul className="space-y-4">
              {philosophyData.willBeList.map((item, index) => (
                <li key={index} className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-rose-600 flex items-center justify-center flex-shrink-0">
                    <Check className="w-4 h-4 text-white" strokeWidth={2} />
                  </div>
                  <span className="text-rose-700 font-normal">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Optimize For */}
          <div className="space-y-6">
            <p className="text-lg text-gray-600 font-light">
              {philosophyData.optimizeFor}
            </p>
            <ul className="space-y-4">
              {philosophyData.optimizeList.map((item, index) => (
                <li key={index} className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-gray-50 border border-gray-200 flex items-center justify-center flex-shrink-0">
                    <Target className="w-4 h-4 text-gray-600" strokeWidth={1.5} />
                  </div>
                  <span className="text-gray-700 font-light">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
